import classNames from "classnames"
import { useMemo, useRef, useState } from "react"
import { Icon } from "../../ui/Icon/Icon"

export type ProductDetailsItem = {
  content: string
  id: string
  title: string
}

type Props = {
  className?: string
  items: ProductDetailsItem[]
}

export const BuilderProductDetails = ({ className, items }: Props) => {
  const [activeItemId, setActiveItemId] = useState<string | null>(null)
  const contentRefs = useRef<Record<string, HTMLDivElement | null>>({})

  const preparedItems = useMemo(
    () => items.filter((item) => item.title && item.content),
    [items]
  )

  if (preparedItems.length === 0) {
    return null
  }

  return (
    <div className={classNames("Product xl:hidden", className)}>
      <div className="accordion border-t border-[var(--nonchecked-color)]">
        {preparedItems.map((item) => {
          const isActive = activeItemId === item.id
          const contentHeight = contentRefs.current[item.id]?.scrollHeight ?? 0

          return (
            <div
              key={item.id}
              className={classNames("accordion-item", { active: isActive })}
            >
              <h4 className="accordion-item__heading-tag">
                <button
                  className={classNames("accordion-item__heading", {
                    active: isActive,
                  })}
                  id={`builder-accordion-control-${item.id}`}
                  type="button"
                  aria-expanded={isActive}
                  aria-controls={`builder-accordion-panel-${item.id}`}
                  onClick={() => {
                    setActiveItemId((currentItemId) => {
                      return currentItemId === item.id ? null : item.id
                    })
                  }}
                >
                  <div className="accordion-item__title">
                    <span>{item.title}</span>
                  </div>

                  <span className="accordion-item__icon" aria-hidden="true">
                    <Icon className="accordion-item__icon-open Icon--plus-accordion" type="plus-accordion" />
                    <Icon className="accordion-item__icon-close Icon--minus-accordion" type="minus-accordion" />
                  </span>
                </button>
              </h4>

              <div
                ref={(node) => {
                  contentRefs.current[item.id] = node
                }}
                className="accordion-item__content"
                id={`builder-accordion-panel-${item.id}`}
                role="region"
                aria-labelledby={`builder-accordion-control-${item.id}`}
                style={{ maxHeight: isActive ? `${contentHeight}px` : "0px" }}
              >
                <div className="accordion-item__content-inner">
                  <div
                    className="body accordion-item__content-description"
                    dangerouslySetInnerHTML={{ __html: item.content }}
                  />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}